import React, { useState } from "react";
import slide3 from "../../Assets/images/slide3.jpg";
import { motion } from "framer-motion";

const RequestCallback = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/contact/submit-call-back-form`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setLoading(false);
        alert("Form submitted successfully");
        setFormData({
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      } else {
        alert("Error submitting form");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
      alert("Error submitting form");
    }
  };

  const motionVariantsTop = {
    hidden: { opacity: 0, y: -40 },
    visible: { opacity: 1, y: 0 },
  };
  const motionVariantsLeft = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  };
  const motionVariantsRight = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
  };
  const motionProperties = {
    initial: "hidden",
    whileInView: "visible",
    transition: { duration: 1, delay: 0.5 },
    viewport: { once: true },
  };

  return (
    <React.Fragment>
      <div
        style={{
          backgroundImage: `url(${slide3})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        className="w-full h-auto overflow-hidden"
      >
        <div className="flex flex-col mx-auto max-w-7xl px-12 sm:px-6 lg:px-8 py-12 ">
          <div className="flex flex-col gap-4 justify-center items-center">
            <motion.h1
              variants={motionVariantsTop}
              {...motionProperties}
              className="text-white font-bold text-[30px] tracking-wider"
            >
              Request a <span className="text-yellow-500">Callback</span>{" "}
            </motion.h1>
            <div className="h-[2px]"></div>
          </div>

          <div className="flex items-center justify-center">
            <motion.p variants={motionVariantsLeft} {...motionProperties} className="text-white text-center font-semibold md:text-[18px] text-[10px] tracking-wider w-full">
              Book a quick call to talk about how Techmentee might help you landing your next big opportunity
            </motion.p>
          </div>
          <motion.div variants={motionVariantsRight} {...motionProperties} className="flex flex-col gap-3 mt-3 ">
            <div className="flex md:items-start md:justify-start justify-center">
              <h2 className="text-white font-bold text-[20px]">
                How Can We Help ?
              </h2>
            </div>
            <div className="flex items-center justify-center">
              <form
                className="flex flex-wrap md:flex-row flex-col gap-2 lg:gap-3 md:gap-4"
                onSubmit={handleSubmit}
              >
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Enter Email"
                  value={formData.email}
                  onChange={handleChange}
                  className="p-3 text-gray-500"
                  required
                />
                <input
                  type="text"
                  name="phone"
                  id="phone"
                  placeholder="Phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="p-3 text-gray-500"
                  required
                />
                <input
                  type="text"
                  name="subject"
                  id="subject"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="p-3 text-gray-500"
                  required
                />
                <input
                  type="text"
                  name="message"
                  id="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  className="p-3 text-gray-500"
                  required
                />
                <button
                  type="submit"
                  className="text-white bg-primaryDarkColor w-[150px] font-medium py-3 px-4 text-center flex justify-center items-center"
                >
                  {loading ? (
                    <>
                      <svg
                        width="20"
                        height="20"
                        fill="currentColor"
                        class="mr-2 animate-spin"
                        viewBox="0 0 1792 1792"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z"></path>
                      </svg>
                      loading...
                    </>
                  ) : (
                    "Submit Now"
                  )}
                </button>
              </form>
            </div>
          </motion.div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RequestCallback;
